import { default as DiscountsGrid } from "./DiscountsGrid";
import { default as UsedDiscountsGrid } from "./UsedDiscountsGrid";
const DisTypesGrids = {
  DiscountsGrid,
  UsedDiscountsGrid,
};

export default DisTypesGrids;
